module.exports = __webpack_public_path__ + "img/introducePage_show_one.bcffce38.jpg";